var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5099 23.3333H46.4754C44.9744 23.3333 43.8103 22.1787 43.8103 20.6918V2.69231C43.8103 0.265641 46.9189 -0.908564 48.5397 0.910898L64.5611 18.8851C66.0779 20.5883 64.8029 23.3333 62.5099 23.3333ZM49.2414 17.9487H56.4867L49.2414 9.81221V17.9487Z",
    fill: "#131313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0345 41.8205H36.569V47.2051H13.0345V41.8205Z",
    fill: "#131313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0345 54.3846H36.2069V59.7692H13.0345V54.3846Z",
    fill: "#131313"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0345 66.9487H36.569V72.3333H13.0345V66.9487Z",
    fill: "#131313"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1506 34.641H15.2198C13.7188 34.641 12.4914 33.4356 12.4914 31.9487V14.359C12.4914 12.8721 13.7188 11.6667 15.2198 11.6667H35.1504C36.6515 11.6667 37.8362 12.8721 37.8362 14.359V31.9487C37.8362 33.4356 36.6515 34.641 35.1506 34.641ZM17.9224 29.2564H32.4052V17.0513H17.9224V29.2564Z",
    fill: "#131313"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M84 79.4041L73.3925 68.8962C75.774 65.7489 77.186 61.8425 77.186 57.6154C77.186 47.2236 68.6515 38.7692 58.1613 38.7692C47.6711 38.7692 39.1366 47.2236 39.1366 57.6154C39.1366 68.0072 47.6711 76.4615 58.1613 76.4615C62.4285 76.4615 66.3718 75.0626 69.5489 72.7034L80.1565 83.2113L84 79.4041ZM58.1613 71.0769C50.6683 71.0769 44.5721 65.0381 44.5721 57.6154C44.5721 50.1927 50.6683 44.1539 58.1613 44.1539C65.6543 44.1539 71.7505 50.1927 71.7505 57.6154C71.7505 65.0381 65.6545 71.0769 58.1613 71.0769Z",
    fill: "#131313"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7414 28.359H65.1724V34.2821H59.7414V28.359Z",
    fill: "#131313"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9224 84H5.25453C2.35707 84 0 81.6649 0 78.7949V5.20513C0 2.33513 2.35707 0 5.25453 0H40.0086V5.38462H5.43103V78.6154H59.9224V84Z",
    fill: "#131313"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.198d819d6353f139749cbec737d91950.svg";
export { ForwardRef as ReactComponent };